import React, { Component } from 'react';
import Select from 'react-select';

class pdv extends Component {
    constructor(props) {
        super(props);
    }

    async componentDidMount() {}

    render() {
        return ( 
            <div className="wrapper">
                <div className="content-wrapper">
                    <section class="content-header"></section>
                    <section class="content">
                        <div className="card">
                            <div className="card-header">
                                <h3 className="card-title"><i className="fas fa-address-book"></i> PDV</h3>
                            </div>
                            <div className="card-body">
                                <div class="container-fluid">
                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label>Pesquisa Produto</label>
                                                <Select
                                                    id="uf"
                                                    placeholder="Procure o produto pelo código, nome ou código de barra" 
                                                    isSearchable="true"
                                                    isOptionSelected
                                                
                                                />
                                            </div>
                                        </div>
                                            <div class="col-md-8">
                                                <div class="form-group">
                                                <label>Pesquisa Produto</label>
                                                <Select
                                                    id="uf"
                                                    placeholder="Procure o produto pelo código, nome ou código de barra" 
                                                    isSearchable="true"
                                                    isOptionSelected
                                                
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </section>
                </div>
            </div>
        )
    }
}

export default pdv;